import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const Hero = () => {
  const { t } = useLang();
  const h = t.hero;
  const [before, after] = h.title.split(h.titleHl);
  return (
    <section id="top" data-testid="hero-section" className="relative -mt-[72px] overflow-hidden bg-[#060A14] pt-[72px]">
      <div className="absolute inset-y-0 right-0 w-full lg:w-[68%]">
        <img data-testid="hero-image" src="/img/hero.jpg" alt="Premium SUV at night" className="hero-cars h-full w-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#060A14] via-[#060A14]/70 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#060A14] via-transparent to-[#060A14]/40" />
      </div>
      <div className="streak left-[-10%] top-[30%]" />
      <div className="streak streak-2 left-[20%] top-[72%]" />
      <div className="relative mx-auto flex min-h-[620px] max-w-7xl items-center px-5 py-24 lg:min-h-[720px] lg:px-8">
        <div className="hero-rise max-w-2xl">
          <span data-testid="hero-badge" className="inline-flex items-center gap-2 rounded-full border border-[#2F7BFF]/30 bg-[#2F7BFF]/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-[#7FB2FF] backdrop-blur sm:text-xs">
            <span className="h-1.5 w-1.5 rounded-full bg-[#2F7BFF] shadow-[0_0_10px_#2F7BFF]" />{h.badge}
          </span>
          <h1 data-testid="hero-title" className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {before}<span className="text-[#2F7BFF] [text-shadow:0_0_40px_rgba(47,123,255,.55)]">{h.titleHl}</span>{after}
          </h1>
          <p data-testid="hero-subtitle" className="mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">{h.subtitle}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href="/#banners" data-testid="hero-buy-cta" className="group inline-flex items-center gap-2 rounded-full bg-[#2F7BFF] px-7 py-3.5 text-[15px] font-bold text-white shadow-[0_12px_36px_-10px_rgba(47,123,255,.9)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#1F63E0]">
              {h.buyCta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a href="/#contact" data-testid="hero-partner-cta" className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 py-3.5 text-[15px] font-bold text-white backdrop-blur transition-[background-color,border-color] duration-300 hover:border-white/40 hover:bg-white/10">
              {h.sellCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
